import type { TransferState } from "@aasaan-share/ui-contract";

export type TransferActionMode = "available" | "active" | "failed";

export function photoTransferActionMode(
  state: TransferState | undefined,
): TransferActionMode {
  switch (state) {
    case "queued":
    case "starting":
    case "transferring":
    case "verifying":
      return "active";
    case "failed":
      return "failed";
    default:
      return "available";
  }
}

export function videoTransferActionMode(
  state: TransferState | undefined,
): TransferActionMode {
  return photoTransferActionMode(state);
}
